export const getAppearence = () => {
    return JSON.parse(localStorage.getItem("appearence") ?? "null") ?? "dark";
}

export const toggleAppearence = () => {
    const currMode = JSON.parse(localStorage.getItem("appearence") ?? "null") ?? "dark";
    const newMode = currMode === "dark" ? "light" : "dark";
    localStorage.setItem("appearence", JSON.stringify(newMode));
    return newMode;
}

export const cleanAppearence = () => {
    localStorage.removeItem("appearence");
}
